var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0158 7.79017H20.1277C20.6308 7.80881 21.107 8.02186 21.4562 8.38448C21.8054 8.74711 22.0004 9.23104 22 9.73446V11.6698C21.9978 11.91 21.952 12.1479 21.865 12.3719L18.9395 19.2039C18.7913 19.5583 18.5409 19.8605 18.2203 20.0721C17.8997 20.2837 17.5234 20.3951 17.1393 20.3921H8.41694C7.90284 20.3897 7.41062 20.1838 7.04793 19.8194C6.68525 19.4551 6.48164 18.9619 6.48165 18.4478V8.79832C6.48004 8.54475 6.52851 8.29337 6.62428 8.05857C6.72005 7.82378 6.86124 7.61021 7.03973 7.43011L12.4406 2.02929C12.7121 1.7594 13.0794 1.60791 13.4622 1.60791C13.8451 1.60791 14.2123 1.7594 14.4839 2.02929C14.7571 2.30129 14.9123 2.66991 14.9159 3.05544V3.37049L14.0158 7.79017ZM17.2293 18.4478L20.1277 11.6698V9.73446H11.4144L12.7106 4.55867L8.50696 8.76231V18.4478H17.2293ZM2 8.28527H3.9443V19.888H2V8.28527Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeOutlined);
export default __webpack_public_path__ + "static/media/LikeOutlined.33e736bfcd415b3658bfef01939a270f.svg";
export { ForwardRef as ReactComponent };